import { Head } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from '@/components/ui/Card'
import { Ghost, CheckCircle } from 'lucide-react'
import appIcon from '@/assets/images/icon-128.png'
import { AuthBackground } from '@/components/auth/AuthBackground'

export default function EarlyAccessConfirmed() {
  return (
    <>
      <Head title="You're In!" />

      <AuthBackground>
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <img src={appIcon} alt="Banshee" className="size-16 mx-auto mb-2 rounded-xl" />
            <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="size-8 text-primary" />
            </div>
            <CardTitle className="flex items-center justify-center gap-2">
              <Ghost className="size-6" />
              You're on the List!
            </CardTitle>
            <CardDescription>
              Thanks for confirming your email. We'll summon you as soon as Banshee.chat is ready to haunt your inbox.
            </CardDescription>
          </CardHeader>

          <CardContent className="text-center">
            <p className="text-sm text-muted-foreground mb-4">
              In the meantime, follow us for updates:
            </p>
            <div className="flex justify-center gap-6">
              <a
                href="https://bsky.app/profile/banshee.chat"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
                title="Bluesky"
              >
                <svg className="size-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z" />
                </svg>
              </a>
              <a
                href="https://youtube.com/@bansheechat"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
                title="YouTube"
              >
                <svg className="size-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
            </div>
          </CardContent>

          <CardFooter className="justify-center">
            <Button variant="outline" asChild>
              <a href="/login" className="cursor-pointer">Back to Login</a>
            </Button>
          </CardFooter>
        </Card>
      </AuthBackground>
    </>
  )
}
